import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemProjectSelectRoute: InvariantJiraRoute = {
	name: 'global-settings-system-project-select',
	path: '/secure/project/SelectProject(\\w*)([!%]?[\\w]*).jspa',
};
